module.exports = __webpack_public_path__ + "img/10.b4e94bf3.png";